import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id) =>
  makeRequest('post', `/api/roundtables/${roundtable_id}/teacher-submit`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/createTeacherSubmission.js